import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActivityDistanceNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <clipPath id="activity_distance_normal_xsmall_svg__a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
      <g clipPath="url(#activity_distance_normal_xsmall_svg__a)" fill="">
        <path d="M8 7.5a2 2 0 110-4 2 2 0 010 4zm0-3a1 1 0 100 2 1 1 0 000-2z" />
        <path d="M8 16.066L3.589 7.758a4.871 4.871 0 01.88-5.814 5.044 5.044 0 017.062 0 4.87 4.87 0 01.88 5.814zM8 1.5a4.012 4.012 0 00-2.828 1.156 3.88 3.88 0 00-.7 4.631L8 13.934l3.529-6.647a3.88 3.88 0 00-.7-4.631A4.012 4.012 0 007.999 1.5z" />
      </g>
    </svg>
  )
);
SvgActivityDistanceNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgActivityDistanceNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActivityDistanceNormalXsmall;
